import * as types from "./types";

const initialState = {
    loader: true,
    searchParams: {},
    searchResult: [],
    buses: [],
    chart: [],
    selBus: false,
    serviceType: [],
    routeInfo: {},
    routeInfoById: {},
    routePkpDrp: { pickups: [], dropoffs: [], pdroutes: [] },
    fareRange: { min: 0, max: 0 },
    tripInfoById: {},
    order: false,
    couponList: false,
    waitlistmsg: false,
    alert: { show: false, msg: 'Oops! some error occured!' },
    busSort: { sortBy: false, sortOrder: false },
    selPickDtls: {},
    selDropDtls: {},
    selPickId: '',
    seldropoffId: '',
    selBusPick: {},
    serviceRouteDtls: {},
    seatChartErrorMsg: {},
    concessionLevyList: [],
    concessionLevyById: {},
    recaptchaToken: '',
    GroupDiscountFlexi:null,
    linkedCityData:[],


    passOrder: false,
};

const data = function (state = initialState, action) {
    const routeInfoById = { ...state.routeInfoById };
    const tripInfoById = { ...state.tripInfoById };
    const seatChartErrorMsg = { ...state.seatChartErrorMsg };
    const concessionLevyById = { ...state.concessionLevyById };
    switch (action.type) {
        case types.LOADER:
            return {
                ...state,
                loader: action.data
            };
        case types.SEARCHPARAMS:
            return {
                ...state,
                searchParams: action.data
            };
        case types.SEARCHRESULT:
            return {
                ...state,
                searchResult: action.data,
                buses: action.data
            };
        case types.MODIFYSEARCHRESULT:
            return {
                ...state,
                buses: action.data
            };
        case types.CHARTDATA:
            return {
                ...state,
                chart: action.data
            };
        case types.SELBUS:
            return {
                ...state,
                selBus: action.data
            };
        case types.UPDATESERVICETYPES:
            return {
                ...state,
                serviceType: action.data
            };
        case types.ROUTEINFO:
            return {
                ...state,
                routeInfo: action.data
            };
        case types.ROUTEINFOBYID:
            routeInfoById[action.routeId] = action.data;
            return {
                ...state,
                routeInfoById
            };
        case types.TRIPINFOBYID:
            tripInfoById[action.routeId] = action.data;
            return {
                ...state,
                tripInfoById
            };

        case types.UPDATESEATCHARTERROR:
            seatChartErrorMsg[action.rsid] = action.msg;
            return {
                ...state,
                seatChartErrorMsg
            }

        case types.ORDERDATA:
            return {
                ...state,
                order: action.data
            };
        case types.COUPONLIST:
            return {
                ...state,
                couponList: action.data
            };
        case types.ALERT:
            return {
                ...state,
                alert: action.data
            };

        case types.WAITLISTMSG:
            return {
                ...state,
                waitlistmsg: action.data
            };
        case types.UPDATEBUSSORT:
            return {
                ...state,
                busSort: action.data
            }
        case types.UPDATESELPICKDTLS:
            return {
                ...state,
                selPickId: action.selPickId,
                selPickDtls: action.data
            }
        case types.UPDATESELDROPDTLS:
            return {
                ...state,
                seldropoffId: action.seldropoffId,
                selDropDtls: action.data
            }
        case types.UPDATESELBUSPICKINFO:
            return {
                ...state,
                selBusPick: action.data
            }
        case types.UPDATESERVICEROUTEINFO:
            return {
                ...state,
                serviceRouteDtls: action.data
            }
        case types.UPDATE_ROUTES_PKPDRP:
            return {
                ...state,
                routePkpDrp: action.data
            }
        case types.UPDATE_FARE_RANGE:
            return {
                ...state,
                fareRange: action.data
            }
        case types.UPDATE_CONCESSION_LEVY_LIST:
            return {
                ...state,
                concessionLevyList: action.data
            }
        case types.UPDATE_CONCESSION_LEVY_FOR_ROUTEID:
            concessionLevyById[action.routeId] = action.data;
            return {
                ...state,
                concessionLevyById
            };
        case types.UPDATE_CAPTCHA_TOKEN:
            return {
                ...state,
                recaptchaToken: action.data
            };
        case types.FLEXIDATA:
            // console.log("action",action.data);
             return {
                ...state,
                GroupDiscountFlexi: action.data
            }; 
        case types.UPDATE_LINKED_CITY_DATA:
             return {
                ...state,
                linkedCityData: action.data
            };  
            
        case types.PASS_ORDER_DATA:
            return {
                ...state,
                passOrder: action.data
            };
        default:
            return state;
    }
}

export default data;